import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn btn-ozonpay",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('btn:click')), ["prevent"]))
  }, [
    _createElementVNode("span", null, [
      _createElementVNode("img", {
        src: _ctx.paymentMethodsHelper.getLogo('ozon'),
        class: "icon"
      }, null, 8, _hoisted_1)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("span", null, "Оплатить через Ozon Банк", -1))
  ]))
}